const menuList = [
  {
    name: 'home',
    title: 'Home',
    link: '/home',
    active: true,
  },
  {
    name: 'projects',
    title: 'Projects',
    link: '/projects',
    active: false,
  },
  {
    name: 'about',
    title: 'About',
    link: '/about',
    active: false,
  },
];

export { menuList };
